import UsersModel from './Users';
import BannersModel from './Banners';
import ToursModel from './Tours';
import OrdersModel from './Orders';
import GroupsModel from './Groups';
import ProductsModel from './Products';
import VouchersModel from './Vouchers';
import PropertiesModel from './Properties';
import RolesModel from './Role';

export default { UsersModel, BannersModel, ToursModel, OrdersModel, GroupsModel, ProductsModel, VouchersModel, PropertiesModel,RolesModel }
